import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { FeedbackEntity } from '../feedback.entity';

export const STATE_NAME = 'feedbackEntity';

export const FeedbackEntityState: GenericEntityStateClass<FeedbackEntity> =
  createEntityState<FeedbackEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class FeedbackEntityService extends EntityService<FeedbackEntity> {
  constructor() {
    super();
    this.resourceType = 'feedback';
    this.stateClass = FeedbackEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): FeedbackEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
